let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3tyCB")).then(() => parcelRequire('2F0Ic'));